export type IFundStatsType = 'operacional' | 'pre-operacional' | 'cancelado';

export enum FUND_STATUS_TYPE {
  operation = 'operacional',
  'preOperational' = 'pre-operacional',
  canceled = 'cancelado',
}
